import { render, staticRenderFns } from "./ImagePredict.vue?vue&type=template&id=2835ce36&scoped=true&"
import script from "./ImagePredict.vue?vue&type=script&lang=js&"
export * from "./ImagePredict.vue?vue&type=script&lang=js&"
import style0 from "./ImagePredict.vue?vue&type=style&index=0&id=2835ce36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835ce36",
  null
  
)

export default component.exports